import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShareGiftBox = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 177,
	height: 195,
	viewBox: "0 0 177 195",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M182.051 42.8996L209.055 121.923C210.357 125.734 210.218 129.953 208.67 133.652C207.121 137.351 204.289 140.228 200.796 141.648L75.6932 192.539C72.2006 193.96 68.3338 193.809 64.9434 192.119C61.5531 190.429 58.9168 187.339 57.6147 183.528L30.6106 104.505M82.1718 13.9775C80.4724 9.00455 77.4596 4.69304 73.5144 1.58824C69.5691 -1.51655 64.8687 -3.27519 60.0074 -3.46528C55.1461 -3.65536 50.3423 -2.26837 46.2035 0.520326C42.0647 3.30902 38.7767 7.37415 36.7554 12.2017C34.7342 17.0292 34.0703 22.4022 34.8478 27.6414C35.6253 32.8806 37.8093 37.7505 41.1236 41.6354C44.4378 45.5203 48.7335 48.2457 53.4674 49.4669C58.2013 50.6881 63.1608 50.3503 67.7187 48.4961L90.7639 39.1215M82.1718 13.9775L90.7639 39.1215M82.1718 13.9775C80.4724 9.00455 80.1627 3.59341 81.282 -1.57159C82.4013 -6.73659 84.8992 -11.4235 88.4598 -15.0396C92.0205 -18.6556 96.4839 -21.0385 101.286 -21.8868C106.088 -22.7351 111.012 -22.0108 115.437 -19.8055C119.861 -17.6001 123.587 -14.0127 126.143 -9.497C128.699 -4.98128 129.97 0.259971 129.796 5.56397C129.622 10.868 128.01 15.9965 125.164 20.301C122.319 24.6055 118.367 27.8927 113.809 29.7468L90.7639 39.1215M90.7639 39.1215L134.952 168.433M27.3184 105.844L185.343 41.5604C190.795 39.3426 193.57 32.7151 191.537 26.7667L186.627 12.3988C184.595 6.45042 178.52 3.42273 173.068 5.64051L15.0438 69.924C9.592 72.1417 6.81701 78.7693 8.84968 84.7176L13.7595 99.0856C15.7922 105.034 21.8666 108.062 27.3184 105.844Z",
		stroke: "url(#paint0_linear_share_gift_box)",
		strokeOpacity: .1,
		strokeWidth: 15.4027,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_share_gift_box",
		x1: 76.8717,
		y1: -12.5056,
		x2: 148.272,
		y2: 163.015,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "rgb(var(--repeatmd-brand-color))"
		})]
	}) })]
});
export default SvgShareGiftBox;
